export default "__VITE_ASSET__2e425ee8__"